import React from 'react';
import {useEffect, useState} from 'react';
import './TrafficLight.less';
import {Popup} from 'semantic-ui-react';
import moment from 'moment';
import {DateFormatter} from 'src/utils/DateFormatter';

const Light = ({backgroundColor, lastUpdatedOn}: any) => {
    return (
        <>
            {lastUpdatedOn && backgroundColor !== 'green' ?
                <Popup trigger={<div aria-hidden={true} className="traffic-light" style={{backgroundColor}} />} position="top center">
                    {DateFormatter.applyDateTime24HRSFormat(lastUpdatedOn) || ""}
                </Popup>
                : <div aria-hidden={true} className="traffic-light" style={{backgroundColor}} />}
        </>
    );
};

export default function TrafficLight({
    initialColor,
    lastUpdatedOn = undefined,
    config,
}: any) {

    return (
        <div
            aria-live="polite"
            aria-label={`Current light: ${initialColor}`}
            className="traffic-light-container traffic-light-container--vertical"
        >
            {Object.keys(config).map((color) => (
                <Light
                    key={color}
                    lastUpdatedOn={lastUpdatedOn}
                    backgroundColor={
                        color === initialColor
                            ? config[color].backgroundColor
                            : undefined
                    }
                />
            ))}
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/TrafficLight.tsx